import PropTypes from 'prop-types';
import React from 'react';
import Textarea from 'react-textarea-autosize';
import styles from '../Event.scss';

export default class TitleEdit extends React.Component {

  static propTypes = {
    title: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    commitUpdate: PropTypes.func.isRequired,
    closeHandler: PropTypes.func
  }

  constructor(props) {
    super(props);
    this.state = {
      title: this.props.title
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentWillUnmount() {
    this.props.commitUpdate();
  }

  handleChange(e) {
    this.setState({ title: e.target.value });
    this.props.onChange(e);
  }

  render() {
    return (
      <div onBlur={this.props.closeHandler}>
        <Textarea
          autoFocus
          value={this.state.title}
          placeholder='(Untitled Event)'
          rows={1}
          name='title'
          onChange={this.handleChange}
          className={styles.title}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Event/Show/TitleInput.js